<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="
      flex flex-col justify-center
      [&_button:not(:last-child)]:py-6
      [&_button:last-child]:my-auto
      [&>nav>div]:px-0
    "
  >
    <div
      v-if="showSearch"
      class="w-full flex flex-row gap-x-8 justify-end sm:justify-start max-container"
    >
      <a
        id="sds-megamenu__top-link_home"
        href="/"
        data-id="sds-megamenu_home"
        data-selected="false"
        class="hidden sm:flex sm:flex-col justify-center h-[calc(64px+2px)] hover:z-30 mr-auto hover:text-red-600 border-transparent! items-center gap-0.5 xl:gap-1 my-auto space-x border-b-2 group overflow-y-visible select-none shrink-0 text-sm xl:text-base focus-visible:outline-2 cursor-pointer gtm-1-mm"
        role="menuitem"
      >
        <SeiWordmark
          extra-classes="w-60! sm:w-2xs! sm:h-10 lg:w-60! xl:w-sm! 2xl:w-[400px]! pr-4 text-black hover:text-red-600 focus:text-red-600"
          :cmu="false"
        />
        <span class="sr-only">Home</span>
      </a>
      <div
        class="bg-gray-25 flex flex-row -mx-4 sm:ml-auto border-b-2 sm:border-red-600 animate-grow"
      >
        <div class="flex flex-col justify-center w-full">
          <input
            id="search-input"
            type="text"
            placeholder="Search sei.cmu.edu"
            class="
              bg-gray-25
              h-10 sm:h-auto
              w-full
              border-none
              caret-red-600
              focus:shadow-none!
              focus:ring-transparent
              focus:outline-none
              pl-4 py-0 my-auto
            "
            @keyup.enter="search"
          />
        </div>
        <div class="flex flex-col justify-center">
          <svg
            width="14" height="14"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="
              px-[17px]
              py-1.5
              sm:py-[25.5px]
              lg:py-6
              mt-px
              text-gray-500
              h-full w-12
              hover:text-red-600 focus:text-red-600
              select-none
            "
            tabindex="0"
            @click="search"
            @keyup.enter="search"
          >
            <path
              d="M9.75 4.875C9.75 5.95312 9.39844 6.9375 8.8125 7.75781L11.7891 10.7109C12.0703 11.0156 12.0703 11.4844 11.7891 11.7891C11.4844 12.0703 11.0156 12.0703 10.7109 11.7891L7.75781 8.8125C6.9375 9.39844 5.95312 9.75 4.875 9.75C2.17969 9.75 0 7.57031 0 4.875C0 2.17969 2.17969 0 4.875 0C7.57031 0 9.75 2.17969 9.75 4.875ZM4.875 8.25C6.75 8.25 8.25 6.75 8.25 4.875C8.25 3 6.75 1.5 4.875 1.5C3 1.5 1.5 3 1.5 4.875C1.5 6.75 3 8.25 4.875 8.25Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div class="flex flex-col justify-center">
          <div class="flex flex-row">
            <div class="w-px h-7 my-auto bg-gray-100 relative"></div>
            <svg
              width="30" height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="
                cursor-pointer
                py-[5px]
                sm:py-3.5
                px-2
                sm:px-1.5
                text-gray-500 h-full
                w-12
                sm:w-12
                hover:text-red-600 focus:text-red-600
                select-none
              "
              tabindex="0"
              @click="toggleSearch"
              @keyup.enter="toggleSearch"
            >
              <path
                d="M11.7891 11.2109L15.0234 14.4453L18.2344 11.2109C18.5156 10.9297 19.0078 10.9297 19.2891 11.2109C19.5938 11.5156 19.5938 11.9844 19.2891 12.2891L16.0781 15.5L19.2891 18.7109C19.5938 19.0156 19.5938 19.4844 19.2891 19.7891C19.0078 20.0703 18.5156 20.0703 18.2344 19.7891L15.0234 16.5547L11.7891 19.7891C11.5078 20.0703 11.0156 20.0703 10.7344 19.7891C10.4297 19.4844 10.4297 19.0156 10.7344 18.7109L13.9453 15.5L10.7344 12.2891C10.4297 11.9844 10.4297 11.5156 10.7344 11.2109C11.0156 10.9297 11.5078 10.9297 11.7891 11.2109Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <SdsMegaMenu
      v-model="megamenu"
      v-else
      type="underline"
      :width="width"
    >
      <template #link(home)>
        <SeiWordmark
          extra-classes="w-60! sm:w-2xs! lg:w-60! xl:w-sm! 2xl:w-[400px]! pr-4 text-black hover:text-red-600 focus:text-red-600"
          :cmu="false"
        />
        <span class="sr-only">Home</span>
      </template>
      <template
        v-for="panel in megamenu as Array<TopLevelItem>"
        :key="panel.key"
        #[`panel(${panel.key})`]="{ content=panel.content }"
      >
        <Cols
          v-if="content.proportion"
          :proportion="content.proportion"
          :width="width"
        >
          <template
            v-if="content.col_1"
            #one
          >
            <MenuItem
              v-for="item, i in content.col_1.items"
              :key="item.key"
              :i="i"
              :item="item"
            />
          </template>
          <template
            v-if="content.col_2"
            #two
          >
            <MenuItem
              v-for="item, i in content.col_2.items"
              :key="item.key"
              :i="i"
              :item="item"
            />
          </template>
          <template
            v-if="content.col_3"
            #three
          >
            <MenuItem
              v-for="item, i in content.col_3.items"
              :key="item.key"
              :i="i"
              :item="item"
            />
          </template>
        </Cols>
      </template>
      <template #link(search)>
        <div class="flex flex-col justify-center">
          <div class="flex flex-row">
            <div class="hidden lg:block w-px h-7 my-auto bg-gray-100 relative -left-1"></div>
            <svg
              width="14"
              height="14"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="
                px-[9px] py-3.5 sm:py-6
                text-gray-500
                h-full w-8
                my-auto
                relative
                hover:text-red-600 focus:text-red-600
                select-none
              "
              tabindex="0"
              @keyup.enter="toggleSearch"
            >
              <path
                d="M9.75 4.875C9.75 5.95312 9.39844 6.9375 8.8125 7.75781L11.7891 10.7109C12.0703 11.0156 12.0703 11.4844 11.7891 11.7891C11.4844 12.0703 11.0156 12.0703 10.7109 11.7891L7.75781 8.8125C6.9375 9.39844 5.95312 9.75 4.875 9.75C2.17969 9.75 0 7.57031 0 4.875C0 2.17969 2.17969 0 4.875 0C7.57031 0 9.75 2.17969 9.75 4.875ZM4.875 8.25C6.75 8.25 8.25 6.75 8.25 4.875C8.25 3 6.75 1.5 4.875 1.5C3 1.5 1.5 3 1.5 4.875C1.5 6.75 3 8.25 4.875 8.25Z"
                fill="currentColor"
              />
            </svg>
            <span class="sr-only">Search</span>
          </div>
        </div>
      </template>
      <template #link(mobile-menu)>
        <div class="flex flex-row -mr-2">
          <div class="w-px h-7 my-auto bg-gray-100 relative -left-2"></div>
          <svg
            width="11"
            height="9"
            viewBox="0 0 11 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="
              px-2.5 py-4 sm:py-7
              text-gray-500
              h-full my-auto w-8
              relative
              hover:text-red-600 focus:text-red-600
              select-none
            "
            tabindex="0"
            @keyup.enter="togglePanel"
          >
            <path
              d="M0 0.75C0 0.328125 0.328125 0 0.75 0H9.75C10.1719 0 10.5 0.328125 10.5 0.75C10.5 1.17188 10.1719 1.5 9.75 1.5H0.75C0.328125 1.5 0 1.17188 0 0.75ZM0 4.5C0 4.07812 0.328125 3.75 0.75 3.75H9.75C10.1719 3.75 10.5 4.07812 10.5 4.5C10.5 4.92188 10.1719 5.25 9.75 5.25H0.75C0.328125 5.25 0 4.92188 0 4.5ZM10.5 8.25C10.5 8.67188 10.1719 9 9.75 9H0.75C0.328125 9 0 8.67188 0 8.25C0 7.82812 0.328125 7.5 0.75 7.5H9.75C10.1719 7.5 10.5 7.82812 10.5 8.25Z"
              fill="currentColor"
            />
          </svg>
          <span class="sr-only">Mobile Menu</span>
        </div>
      </template>
    </SdsMegaMenu>
  </div>
  <div class="flex lg:hidden">
    <SdsMobileMenu
      v-model="showPanel"
      :mobile-menus="mobilemenu"
      side="right"
    >
      <template #title>
        <SeiWordmark
          extra-classes="mr-4"
          :cmu="false"
        />
      </template>
      <template #default="{ navigate }">
        <div
          v-for="(m, i) in mobilemenu"
          :key="m.key"
        >
          <SdsNavigationItem
            :key="m.key"
            :label="m.label"
            :href="m.href"
            :type="m.type"
            :selected="m.selected ?? false"
            @click="navigate(m.key)"
          />
          <hr
            v-if="i !== mobilemenu.length-1"
            class="mt-2 mb-2 border-gray-100 dark:border-gray-700"
          >
        </div>
      </template>
      <template
        v-for="panel in mobilemenu"
        :key="panel.key"
        #[`panel(${panel.key})`]="{ navigate }"
      >
        <MobilePanel
          :children="panel.content.children"
          :navigate="navigate"
        />
      </template>
    </SdsMobileMenu>
  </div>
</template>

<script setup lang="ts">
import { ref, onUpdated, onBeforeMount } from 'vue';
import { waitForElem } from '../../../ts/utils/wait_for_elem';
import Cols from '../Cols/Cols.vue';
import SeiWordmark from '../SeiWordmark/SeiWordmark.vue';
import MobilePanel from './MobilePanel.vue';

export interface Item {
  id: string,
  type: 'link' | 'page' | 'feed',
  value: {
    label: string,
    link_type?: {
      cta: boolean,
      description: string,
      external: boolean,
      style: 'landing-page' | 'simple' | 'descriptive'
    },
    page_or_url?: {
      custom_url: string | null,
      link_to: string,
      new_window: boolean,
      page: string | null,
    },
    feed_items?: Array<{
      href: string,
      title: string,
      external: boolean
    }>
  }
}

export interface TopLevelItem {
  key: string,
  title: string,
  sort_order: number,
  type?: string,
  content?: {
    proportion?: string,
    col_1?: Item,
    col_2?: Item,
    col_3?: Item
  }
}

interface MenuObject {
  menu: {
    active: boolean,
    name: string
  },
  menu_items: TopLevelItem[]
}

interface MegaMenuData {
  meta?: {
    total_count: number
  } | null,
  items?: MenuObject[],
  uuid?: string
}

const props = withDefaults(defineProps<MegaMenuData>(), {
  meta: null,
  items: () => [],
  uuid: ''
});


defineOptions({
  name: "MegaMenu"
})

const megamenu = ref([]);
const mobilemenu = ref([]);

const width = ref("full");
const showPanel = ref(false)
const showSearch = ref(false)

const togglePanel = () => {
  showPanel.value = !showPanel.value
}

const toggleSearch = () => {
  showSearch.value = !showSearch.value
}

const search = () => {
  if (!rootElement.value.querySelector('#search-input')) return;
  const inputValue = (rootElement.value.querySelector('#search-input') as HTMLInputElement).value.trim();
  if (inputValue === '') return;
  window.location.href = `/search/?q=${encodeURIComponent(inputValue)}`;
}

const clean_mega_data = (data: MenuObject[]) => {
  megamenu.value.push({
    key: 'home',
    title: 'Home',
    alignment: 'left',
    tag: 'a',
    href: '/',
    sort_order: 0
  })
  data?.forEach((m) => {
    if (m["menu"]["active"] === true) {
      megamenu.value.push(m["menu_items"])
    }
  })
  megamenu.value.push({
    key: 'search',
    title: 'Search',
    tag: 'a',
    onClick: () => toggleSearch(),
    content: {
      proportion: false
    },
    sort_order: 9998
  })
  megamenu.value.push({
    key: 'mobile-menu',
    title: 'Mobile Menu',
    tag: 'a',
    onClick: () => togglePanel(),
    content: {
      proportion: false
    },
    sort_order: 9999
  })
}

const clean_mobile_data = (data: MenuObject[]) => {
  data?.forEach((m) => {
    if (m["menu"]["active"] === true) {
      const menu_items = {
        key: m["menu_items"]["key"],
        label: m["menu_items"]["title"],
        sort_order: m["menu_items"]["sort_order"],
        href: null,
        type: "slide",
        selected: m["menu_items"]["selected"] ?? false,
        content: {
          children: []
        }
      }

      const addItems = (item: Item, column: number = 0) => {
        if (item.type === "link" || item.type === "page") {
          const menu_item = {
            key: item?.id,
            label: item?.value.label,
            href: item?.value.page_or_url?.custom_url ?
              item?.value.page_or_url?.custom_url :
              item?.value.page_or_url?.page,
            external: item.value.link_type?.external ?? false,
            column: column,
            type: item.value.link_type?.style ?? 'simple',
            cta: item.value.link_type?.cta ?? false
          }
          menu_items.content.children.push(menu_item)
        } else if (item.type === "feed") {
          item.value?.feed_items?.forEach((feedItem) => {
            const menu_item = {
              key: feedItem['href'].split('/')[-1],
              label: feedItem['title'],
              external: feedItem['external'],
              href: feedItem['href'],
              column: column,
              type: 'simple'
            }
            menu_items.content.children.push(menu_item)
          });
        }
      }

      if (["col_1", "col_2", "col_3"].includes(m["menu_items"]["type"])) {
        const col_1_items: Array<Item> = m["menu_items"]["content"]["col_1"]["items"];
        col_1_items?.forEach((item) => {
          addItems(item, 1)
        })
      }

      if (["col_2", "col_3"].includes(m["menu_items"]["type"])) {
        const col_2_items: Array<Item> = m["menu_items"]["content"]["col_2"]["items"];
        col_2_items?.forEach((item) => {
          addItems(item, 2)
        })
      }

      if (m["menu_items"]["type"] === "col_3") {
        const col_3_items: Array<Item> = m["menu_items"]["content"]["col_3"]["items"];
        col_3_items?.forEach((item) => {
          addItems(item, 3)
        })
      }

      mobilemenu.value.push(menu_items)
    }
  })
}

onUpdated(() => {
  if (showSearch.value) {
    rootElement.value.querySelector('#search-input')?.focus()
    rootElement.value.querySelector('nav[data-id="sds-megamenu"] > div[role="menu"]')?.classList.add('hidden')
  }
  if (showPanel.value) {
    rootElement.value.querySelector('nav[data-id="sds-megamenu"] > div[role="menu"]')?.classList.add('hidden')
  }
  /**
   * NOTE:
   * Track clicks on a top-level item by adding the .gtm-1-mm class,
   * consult with Laura Aguera if this needs to be updated.
   * Dan — 06/18/2024
   */
  /* Mega menu top-links */
  waitForElem('[id^="sds-megamenu__top-link_"]').then((items: HTMLElement[]) => {
    items?.forEach((link) => {
      link.classList.add('gtm-1-mm')
    })
  })
  waitForElem('[id^="sds-megamenu__top-link_"] span').then((items: HTMLElement[]) => {
    items?.forEach((link) => {
      link.classList.add('gtm-1-mm')
    })
  })
  waitForElem('[id^="sds-megamenu__top-link_"] svg').then((items: HTMLElement[]) => {
    items?.forEach((link) => {
      link.classList.add('gtm-1-mm')
    })
  })
  /* Mobile menu top-links */
  waitForElem('[id^="sds-navigationitem__"]').then((items: HTMLElement[]) => {
    items?.forEach((link) => {
      link.classList.add('gtm-1-mm')
    })
  })
  /* Mobile menu secondary links */
  waitForElem('[id="sds-navigationitem"]').then((items: HTMLElement[]) => {
    items?.forEach((link) => {
      link.classList.add('gtm-2-mm')
    })
  })
})

const rootElement = ref()

onBeforeMount(() => {
  // Delete JSON from data-json attribute in markup
  rootElement.value = (document.querySelector(`[data-uuid="${props.uuid}"]`) as HTMLElement);
  delete rootElement.value.dataset['json']
  // console.log(props.items)
  // Sort by sort_order from Wagtail
  const items = props.items
  items.sort((a, b) => {
    const aOrder = a.menu_items[0]?.sort_order ?? 0;
    const bOrder = b.menu_items[0]?.sort_order ?? 0;
    return aOrder - bOrder;
  });
  clean_mega_data(items);
  clean_mobile_data(items);
})
</script>

<style scoped lang="css">
@keyframes grow {
  0% {
    opacity: 0;
    transform: scaleX(0.5);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}

.animate-grow {
  width: calc(100% + 2rem);
  transform-origin: right;
  animation: grow 500ms ease forwards;
}
</style>
